import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ApiResponse } from '@/types/addContainerBlExportType';

type Validated = {
  oidVisita: number;
  oidLiquidacion: number;
  lateArrival: boolean;
  fechaIngreso: string;
};

export const addContainerBookingExport = async (
  query: Validated
): Promise<ApiResponse['value']> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.AddContainersBLExport,
      query
    );
    if (res?.data?.value?.ok === false) {
      throw new Error(res?.data?.value?.mensaje);
    }

    if (res?.data?.value?.error) {
      throw new Error(res?.data?.value?.error);
    }

    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
